export const LIST_AUDIT_REQUEST = 'LIST_AUDIT_REQUEST';
export const LIST_AUDIT_REQUEST_SUCCESS = 'LIST_AUDIT_REQUEST_SUCCESS';
export const LIST_AUDIT_REQUEST_FAILURE = 'LIST_AUDIT_REQUEST_FAILURE';

export const CLEAR_AUDIT_LIST = 'CLEAR_AUDIT_LIST';

// list audits users
export const LIST_AUDITS_USERS_REQUEST = 'LIST_AUDITS_USERS_REQUEST';
export const LIST_AUDITS_USERS_REQUEST_SUCCESS = 'LIST_AUDITS_USERS_REQUEST_SUCCESS';
export const LIST_AUDITS_USERS_REQUEST_FAILURE = 'LIST_AUDITS_USERS_REQUEST_FAILURE';

export const CLEAR_AUDITS_USERS_LIST = 'CLEAR_AUDITS_USERS_LIST';

// treasury audit list
export const LIST_TREASURY_AUDIT_REQUEST = 'LIST_TREASURY_AUDIT_REQUEST';
export const LIST_TREASURY_AUDIT_REQUEST_SUCCESS = 'LIST_TREASURY_AUDIT_REQUEST_SUCCESS';
export const LIST_TREASURY_AUDIT_REQUEST_FAILURE = 'LIST_TREASURY_AUDIT_REQUEST_FAILURE';
export const CLEAR_TREASURY_AUDIT_LIST = 'CLEAR_TREASURY_AUDIT_LIST';

// treasury audit detail
export const GET_TREASURY_AUDIT_DETAIL_REQUEST = 'GET_TREASURY_AUDIT_DETAIL_REQUEST';
export const GET_TREASURY_AUDIT_DETAIL_REQUEST_SUCCESS = 'GET_TREASURY_AUDIT_DETAIL_REQUEST_SUCCESS';
export const GET_TREASURY_AUDIT_DETAIL_REQUEST_FAILURE = 'GET_TREASURY_AUDIT_DETAIL_REQUEST_FAILURE';
export const CLEAR_TREASURY_AUDIT_DETAIL = 'CLEAR_TREASURY_AUDIT_DETAIL';